/**
 * Guest/welcome entry to Dev Tools for INDEX 0 (dev hub) only.
 * Hidden on all production white-label clients.
 */
import React, { useMemo } from 'react';
import { StyleSheet, Text, type StyleProp, type ViewStyle } from 'react-native';
import { Clickable2 } from '../../components/common/Clickable2';
import { useAuthNavigation } from '../../shared/navigation/useAuthNavigation';
import { appTheme, useThemeColors } from '../../shared/theme';
import { androidScaleSize } from '../../shared/theme/androidUiParity';
import { isDevHubClient } from '../environment/devHub';

type DevHubGuestDevToolsEntryProps = {
  style?: StyleProp<ViewStyle>;
};

export function DevHubGuestDevToolsEntry({ style }: DevHubGuestDevToolsEntryProps) {
  const navigation = useAuthNavigation();
  const colors = useThemeColors() ?? appTheme.colors;
  const styles = useMemo(
    () =>
      StyleSheet.create({
        pill: {
          minHeight: androidScaleSize(32),
          paddingHorizontal: appTheme.spacing.md,
          borderRadius: 16,
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: colors.surface,
          borderWidth: StyleSheet.hairlineWidth,
          borderColor: colors.borderLight,
        },
        label: {
          ...appTheme.typography.bodySmall,
          fontWeight: '700',
          color: colors.primary,
          letterSpacing: 0.3,
        },
      }),
    [colors],
  );

  if (!isDevHubClient()) {
    return null;
  }

  return (
    <Clickable2
      onPress={() => navigation.navigate('DevTools')}
      haptics
      style={[styles.pill, style]}
      accessibilityLabel="Dev Tools"
      accessibilityRole="button">
      <Text style={styles.label}>Dev</Text>
    </Clickable2>
  );
}
